module.exports = __webpack_public_path__ + "img/digital_card_title.c7ce9168.png";